import { Api } from '@/services/Api'

const rootPath = '/invoice'

export default {
  invoiceNo (entityId) {
    return Api().post(`${rootPath}/get-invoice-no/${entityId}/`)
  },
  get (pk) {
    return Api().get(`${rootPath}/invoice/${pk}/`)
  },
  list (entityId, isPaid, page = 1) {
    return Api().get(`${rootPath}/invoice/?entity=${entityId}&is_paid=${isPaid}&page=${page}`)
  },
  create (data) {
    return Api().post(`${rootPath}/invoice/`, data)
  },
  update (pk, data) {
    return Api().put(`${rootPath}/invoice/${pk}/`, data)
  },
  partial_update (pk, data) {
    return Api().patch(`${rootPath}/invoice/${pk}/`, data)
  },
  delete (pk) {
    return Api().delete(`${rootPath}/invoice/${pk}/`)
  },
  addPayment (pk, data) {
    return Api().post(`${rootPath}/invoice/${pk}/add-payment/`, data)
  },
  cancelPayment (pk, paymentID) {
    return Api().post(`${rootPath}/invoice/${pk}/cancel-payment/`, paymentID)
  },
  sendEmail (pk, data) {
    return Api().post(`${rootPath}/invoice/${pk}/send/`, data)
  }
}
